import colors from "colors";
import { IconProps } from "./types";

export default function IcoArrowUp({
	color = colors.neutral["low-pure-500"],
	size = "16"
}: Readonly<IconProps>) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 20L12 4M12 4L20 12M12 4L4 12"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
